/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./EnWhyCheckPlus.css";
import { Link } from "react-router-dom";
import { renderHomePageHeader } from "../../assets/component/renderHomePageHeader.js";
import { Helmet } from "react-helmet";
import HomepageMenuEn from "../../assets/component/HomepageMenuEn/HomepageMenuEn.js";

class EnWhyCheckPlus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  showModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }
  render() {
    return (
      <div className="EnWhyCheckPlus-view">
        <Helmet>
          <title>Why CheckPlus - CheckPlus</title>
        </Helmet>
        {!!this.state.showModal && (
          <HomepageMenuEn closeModal={this.closeModal} />
        )}
        {renderHomePageHeader(this)}

        <div className="EnWhyCheckPlus-first">
          <div className="EnWhyCheckPlus-heading">Why CheckPlus?</div>
          <div className="EnWhyCheckPlus-scrollContainer">
            <div className="EnWhyCheckPlus-space">
              <div className="EnWhyCheckPlus-centerContent" />
            </div>
            <div className="EnWhyCheckPlus-box">
              <div className="EnWhyCheckPlus-centerContent">
                <div className="EnWhyCheckPlus-CheckPlusLogoCircle">
                  <div className="EnWhyCheckPlus-CheckPlusLogo" />
                </div>

                <div className="EnWhyCheckPlus-logoTxt">CheckPlus</div>
                <div className="EnWhyCheckPlus-list">
                  + As low as HK$150 a month <p />+ Rich features <p />+ Simple
                  to use
                </div>
              </div>
            </div>
            <div className="EnWhyCheckPlus-box">
              <div className="EnWhyCheckPlus-centerContent">
                <div className="EnWhyCheckPlus-developerIcn" />

                <div className="EnWhyCheckPlus-developerTxt">
                  Hire a software developer
                </div>
                <div className="EnWhyCheckPlus-list">
                  - Very Expensive ($2,000-$10,000 per month) <p />- Long
                  Development Time <p />- Potentially buggy
                </div>
              </div>
            </div>
            <div className="EnWhyCheckPlus-box">
              <div className="EnWhyCheckPlus-centerContent">
                <div className="EnWhyCheckPlus-banksIcn" />

                <div className="EnWhyCheckPlus-developerTxt">
                  Banks or Payment Gateway
                </div>
                <div className="EnWhyCheckPlus-list">
                  - Insufficient features <p />- Time consuming to manage <p />-
                  Not user friendly
                </div>
              </div>
            </div>
            <div className="EnWhyCheckPlus-space2">
              <div className="EnWhyCheckPlus-centerContent" />
            </div>
          </div>
        </div>
        <div className="EnWhyCheckPlus-content">
          <div className="EnWhyCheckPlus-checkplusCircle" />
          <div className="EnWhyCheckPlus-heading">
            How is CheckPlus possible?
          </div>
          <div className="EnWhyCheckPlus-subheading">
            CheckPlus has their own team of developers and works with banks like
            HSBC and payment gateways like Stripe and PayPal to make it
            possible.
          </div>
        </div>

        <div className="EnWhyCheckPlus-second">
          <div className="EnWhyCheckPlus-heading EnWhyCheckPlus-whiteTxt">
            Things you can only do with CheckPlus
          </div>
        </div>

        <div className="EnWhyCheckPlus-first">
          <div className="EnWhyCheckPlus-content">
            <div className="EnWhyCheckPlus-heading">
              1. Generate a landing webpage
            </div>
            <div className="EnWhyCheckPlus-subheading">
              By signing up for CheckPlus for Nonprofits, CheckPlus will
              automatically generate a landing webpage uniquely for you. You can
              also add the payment items and donation projects to your page.
            </div>
            <div className="EnWhyCheckPlus-feature1" />
            <div className="EnWhyCheckPlus-heading">
              2. Collect donor’s data during payment
            </div>
            <div className="EnWhyCheckPlus-subheading">
              Not only will CheckPlus collect payment information, the system
              will also collect donor data for your nonprofit on behalf.
            </div>
            <div className="EnWhyCheckPlus-feature2" />
            <div className="EnWhyCheckPlus-heading">
              3. Enable your payers/donors pay with their preferred payment
              method
            </div>
            <div className="EnWhyCheckPlus-subheading">
              Your payers/donors will be presented with the below payment
              methods when they pay.
            </div>
            <div className="EnWhyCheckPlus-CC" />
            <div className="EnWhyCheckPlus-ApplePay" />
            <div className="EnWhyCheckPlus-GooglePay" />
            <div className="EnWhyCheckPlus-paymeBtn" />

            <div className="EnWhyCheckPlus-subtitle">Coming Soon</div>
            <div className="EnWhyCheckPlus-FPS" />
            <div className="EnWhyCheckPlus-paypal" />
            <div className="EnWhyCheckPlus-manualContainer">
              <div className="EnWhyCheckPlus-alipay" />
              <div className="EnWhyCheckPlus-wechatpay" />
              <div className="EnWhyCheckPlus-octopus" />
            </div>
            <div className="EnWhyCheckPlus-manualContainer">
              <div className="EnWhyCheckPlus-bankTransfer"></div>
              <div className="EnWhyCheckPlus-check" />
            </div>

            <div className="EnWhyCheckPlus-heading4">
              4. Set Transaction Type
            </div>
            <div className="EnWhyCheckPlus-subheading">
              You can specify a transaction type for whether it is a payment or
              donation, and CheckPlus will generate the correct receipt type.
            </div>
            <div className="EnWhyCheckPlus-feature4" />
            <div className="EnWhyCheckPlus-heading4">
              5. Automatically generate payment and donation receipt
            </div>
            <div className="EnWhyCheckPlus-subheading">
              CheckPlus will automatically generate and send payment/donation
              receipts to both the donors and your nonprofit.
            </div>
            <div className="EnWhyCheckPlus-feature5" />
            <div className="EnWhyCheckPlus-heading">
              6. Recurring monthly payment/donation
            </div>
            <div className="EnWhyCheckPlus-feature6" />
            <div className="EnWhyCheckPlus-heading4">
              7. Each donor can keep track of their payment/donation history and
              receipts
            </div>
            <div className="EnWhyCheckPlus-feature7"></div>

            <div className="EnWhyCheckPlus-heading">
              8. Generate a single report that includes both payment and donor
              data
            </div>
            <div className="EnWhyCheckPlus-feature8" />
          </div>
        </div>

        <div className="EnWhyCheckPlus-section5">
          <div className="EnWhyCheckPlus-verticalLogo" />
          <div className="EnWhyCheckPlus-txt EnWhyCheckPlus-description5">
            Get started with CheckPlus
          </div>
          <Link to="/OrgLogin">
            <div className="EnWhyCheckPlus-first-bar">Sign Up Now</div>
          </Link>
        </div>

        <div className="EnWhyCheckPlus-footer">
          <div className="EnWhyCheckPlus-footerNav">
            <Link to="/EnTeam">
              <div className="EnWhyCheckPlus-footerNavItem">Our Founders</div>
            </Link>
            <Link to="/EnFaq">
              <div className="EnWhyCheckPlus-footerNavItem">FAQ</div>
            </Link>
            <Link to="/EnContact">
              <div className="EnWhyCheckPlus-footerNavItem">Contact Us</div>
            </Link>

            <Link to="/EnPrivacyPolicy">
              <div className="EnWhyCheckPlus-footerNavItem">Privacy Policy</div>
            </Link>

            <Link to="/EnTerms">
              <div className="En-footerNavItem">Terms and Conditions</div>
            </Link>
          </div>

          <div className="EnWhyCheckPlus-footer_text">
            Flat A, 5/F, Wah Lee Industrial Building
            <br />
            11 Sze Shan Street, Yau Tong, Kowloon, Hong Kong
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. All Rights Reserved.
          </div>
        </div>
      </div>
    );
  }
}

export default EnWhyCheckPlus;
